"use strict"

var stickyContentDefaulClasses = document.querySelector('#stickyContainer').classList.value;
var stickyContainerWidth = stickyPanel.getBoundingClientRect().width + 'px';

document.addEventListener('DOMContentLoaded', function () {
    // console.log('aaaa')
    if (window.innerWidth >= 1200) {
        filterHandler();
    }
});

window.addEventListener('resize', function () {
    if (window.innerWidth >= 1200) {
        // console.log('bbbb')
        stickyContainerWidth = stickyPanel.getBoundingClientRect().width + 'px';
        filterHandler();
    } else {
        document.querySelector('#stickyContainer').className = stickyContentDefaulClasses;
        document.querySelector('#stickyContainer').style.top = '';
        document.querySelector('#stickyContainer').style.bottom = '';
        document.querySelector('#stickyContainer').style.width = '';
    }
});

function filterHandler() {

    const stickyPanel = document.querySelector('#stickyPanel');
    const stickyContent = document.querySelector('#stickyContainer');
    // const stickyContentDefaulClasses = stickyContent.classList.value;



    let stickyPanelTop = null;
    let Z = 0;

    let marginTop = 156;
    let marginBottom = 5;

    window.addEventListener('scroll', Ascroll, false);
    document.body.addEventListener('scroll', Ascroll, false);

    let ro = new ResizeObserver((entries) => {
        for (let entry of entries) {
            const cr = entry.contentRect;

            if (stickyContent.classList.contains('bottom')) {

                stickyContent.style.top = ''
                stickyContent.style.bottom = '7px'
            }

        }
    });

    ro.observe(stickyContent);

    function Ascroll() {

        stickyContent.style.width = stickyContainerWidth;

        let panelRect = stickyPanel.getBoundingClientRect();
        let limitBottom = document.querySelector('#sticky_limit').getBoundingClientRect().bottom;
        if (document.querySelector('#stickyContainer').getBoundingClientRect().height < document.querySelector('#sticky_limit .grid').getBoundingClientRect().height) {
            let contentRect = stickyContent.getBoundingClientRect();
            let contentRectBottomPos = panelRect.top + contentRect.height;
            const viewportHeight = window.visualViewport.height;

            let limitBottomDefaultPos = Math.round(contentRectBottomPos - limitBottom);
            let stickyBottomDefaultPos = Math.round(contentRectBottomPos - viewportHeight);
            if (contentRect.height > viewportHeight) {
                
                if (panelRect.top < stickyPanelTop) {  // скролл вниз
                    // console.log('scroll down');
                    if (stickyBottomDefaultPos + marginBottom > limitBottomDefaultPos) {  // не дойти до низа

                        if (contentRect.bottom - viewportHeight + marginBottom <= 0) {  // подцепиться
                            stickyContent.className = stickyContentDefaulClasses + ' sticky';
                            stickyContent.style.top = viewportHeight - contentRect.height - marginBottom + 'px';
                            stickyContent.style.bottom = '';
                            Z = marginBottom + panelRect.top + contentRect.height - viewportHeight;
                        } else {
                            stickyContent.className = stickyContentDefaulClasses + ' stop';
                            stickyContent.style.top = - Z + 'px';
                            stickyContent.style.bottom = '';
                        }

                    } else {
                        stickyContent.className = stickyContentDefaulClasses + ' stop bottom';
                        stickyContent.style.top = -limitBottomDefaultPos + 'px';
                        stickyContent.style.bottom = '';

                        Z = limitBottomDefaultPos;
                    }

                } else {  // скролл вверх
                    // console.log('scroll up');
                    if (panelRect.top - marginTop < 0) {  // не дойти до верха

                        if (contentRect.top - marginTop >= 0) {  // подцепиться
                            stickyContent.className = stickyContentDefaulClasses + ' sticky';
                            stickyContent.style.top = marginTop + 'px';
                            stickyContent.style.bottom = '';
                            Z = panelRect.top - marginTop;
                        } else { //клик сюда заходит


                            if (stickyContent.classList.contains('bottom')) {
                                stickyContent.className = stickyContentDefaulClasses + ' stop bottom';
                                stickyContent.style.top = '';
                                stickyContent.style.bottom = '7px';
                            } else {
                                stickyContent.className = stickyContentDefaulClasses + ' stop';
                                stickyContent.style.top = -Z + 'px';
                                // stickyContent.style.bottom = '';
                            }

                        }

                    } else {
                        stickyContent.className = stickyContentDefaulClasses;
                        stickyContent.style.top = '';
                        stickyContent.style.bottom = '';
                        Z = 0;
                    }
                }

                stickyPanelTop = panelRect.top;

            } else {
                if ((panelRect.top - marginTop) <= 0) {
                    if ((panelRect.top - marginTop) <= limitBottomDefaultPos) {
                        stickyContent.className = stickyContentDefaulClasses + ' stop';
                        stickyContent.style.top = - limitBottomDefaultPos + 'px';
                        stickyContent.style.bottom = '';
                    } else {
                        stickyContent.className = stickyContentDefaulClasses + ' sticky';
                        stickyContent.style.top = marginTop + 'px';
                        stickyContent.style.bottom = '';
                    }

                } else {
                    stickyContent.className = stickyContentDefaulClasses;
                    stickyContent.style.top = '';
                    stickyContent.style.bottom = '';
                }

            }
        } else {
            stickyContent.className = stickyContentDefaulClasses;
            stickyContent.style.top = '';
            stickyContent.style.bottom = '';
        }
    }

}
